import { render, staticRenderFns } from "./CollectionEditChrome.vue?vue&type=template&id=11569b3e&scoped=true&"
import script from "./CollectionEditChrome.vue?vue&type=script&lang=js&"
export * from "./CollectionEditChrome.vue?vue&type=script&lang=js&"
import style0 from "./CollectionEditChrome.vue?vue&type=style&index=0&id=11569b3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11569b3e",
  null
  
)

export default component.exports